module.exports = __webpack_public_path__ + "static/saksham-kapoor-resume-d65b4bca562d81a40591f6603b79f8d9.pdf";